import React from "react";
import "./Gallery.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";

import g1 from "../../assets/imgs/g1.jpg";
import g2 from "../../assets/imgs/g2.jpg";
import g3 from "../../assets/imgs/g3.jpg";
import g4 from "../../assets/imgs/g4.jpg";
import g5 from "../../assets/imgs/g5.jpg";
import g6 from "../../assets/imgs/g6.jpg";

export default function Gallery() {
  const imgs = [g1, g2, g3, g4, g5, g6];

  return (
    <div className="gly" id="gallery">
      <div className="maxW">
        <div className="swibWrp">
          <h2 className="glyHd">Gallery</h2>

          <div className="swiBtns">
            <button type="button" className="navPrev" aria-label="Previous slide">
              ❮
            </button>
            <button type="button" className="navNext" aria-label="Next slide">
              ❯
            </button>
          </div>
        </div>
      </div>

      <div className="glySwiper">
        <Swiper
          modules={[Autoplay, Navigation]}
          slidesPerView={4.3}
          spaceBetween={25}
          loop
          autoplay={{
            delay: 1800,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          navigation={{
            nextEl: ".navNext",
            prevEl: ".navPrev",
          }}
          grabCursor
          breakpoints={{
            1100: { slidesPerView: 3.8, spaceBetween: 22 },
            992: { slidesPerView: 4.8, spaceBetween: 22 },
            768: { slidesPerView: 2.8, spaceBetween: 18 },
            480: { slidesPerView: 1.8, spaceBetween: 20 },
            320: { slidesPerView: 1, spaceBetween: 20 },
          }}
        >
          {imgs.map((img) => (
            <SwiperSlide key={img}>
              <div className="glyBox">
                <img src={img} alt="Gallery image" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
